(function () {
  if (!location.pathname.includes("/cart")) return;

  let running = false;

  const showMsg = (text) => {
    let box = document.querySelector("[data-bundle-guard-msg]");
    if (!box) {
      box = document.createElement("div");
      box.setAttribute("data-bundle-guard-msg", "1");
      box.style.padding = "12px";
      box.style.border = "1px solid #ddd";
      box.style.margin = "12px 0";
      box.style.borderRadius = "10px";
      box.style.fontSize = "14px";
      box.style.lineHeight = "1.4";
      (document.querySelector("main") || document.body).prepend(box);
    }
    box.textContent = text;
  };

  const fetchCart = async () => {
    const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return r.ok ? r.json() : null;
  };

  const removeLineByKey = async (key) => {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  };

  async function guardOnce() {
    if (running) return;
    running = true;

    try {
      const cart = await fetchCart();
      if (!cart || !Array.isArray(cart.items)) return;

      // uid bazında grupla
      const groups = new Map(); // uid -> { mainQty, extraQty, giftKeys[] }

      // uid olmayan hediyeleri de yakala
      const orphanGiftKeys = [];

      for (const item of cart.items) {
        const p = item.properties || {};
        const uid = p._bundle_uid;
        const role = p._bundle_role;

        const titleLower = String(item.title || "").toLowerCase();
        const looksGift = titleLower.includes("hediye"); // fallback

        const isGift = role === "gift" || looksGift;

        if (!uid) {
          if (isGift) orphanGiftKeys.push(item.key);
          continue;
        }

        if (!groups.has(uid)) groups.set(uid, { mainQty: 0, extraQty: 0, giftKeys: [] });
        const g = groups.get(uid);

        if (role === "main") g.mainQty += item.quantity || 0;
        if (role === "extra") g.extraQty += item.quantity || 0;
        if (isGift) g.giftKeys.push(item.key);
      }

      const toRemove = [];

      // ✅ 3’lü paket kuralı: gift varsa mainQty>0 ve extraQty>=2 olmalı
      for (const [uid, g] of groups.entries()) {
        if (g.giftKeys.length > 0) {
          const ok = g.mainQty > 0 && g.extraQty >= 2;
          if (!ok) g.giftKeys.forEach((k) => toRemove.push(k));
        }
      }

      // uid’siz hediye: direkt sil (0 TL suistimal olmasın)
      orphanGiftKeys.forEach((k) => toRemove.push(k));

      if (toRemove.length) {
        const uniq = Array.from(new Set(toRemove));
        for (const key of uniq) await removeLineByKey(key);

        showMsg("Kampanya koşulları sağlanmadığı için hediye ürün sepetinizden çıkarıldı.");
        location.reload();
      }
    } finally {
      running = false;
    }
  }

  // ✅ ilk açılış
  document.addEventListener("DOMContentLoaded", guardOnce);
  window.addEventListener("pageshow", guardOnce);

  // ✅ AJAX cart update yakalama (temalar genelde fetch ile change.js/update.js çağırır)
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
      if (
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/add")
      ) {
        // cart güncellemesinden sonra kontrol
        setTimeout(guardOnce, 400);
      }
    } catch (e) {}

    return res;
  };
})();
